import { useFilters } from "@/components/filters";
import { Stack, StackProps } from "@mui/material";
import { CajaApertura } from "@/shared/types/caja-apertura";
import { formatDate } from "@/shared/formats";
import { Dialog, ModalHeader, ModalValueExtractor, useOpenModal } from "@/components/modal";
import { DataFetcher } from "@/components/display";
import { useGetAllCajaActualAperturaMovimientosQuery } from "../api/get-all-caja-actual-apertura-movimientos";
import { GetCajaActualAperturaMovimientoQuery } from "../api/get-caja-actual-apertura-movimiento";
import SharedViewCajaAperturaMovimientos from "../../shared/components/shared-view-caja-apertura-movimientos";
import SharedViewCajaMovimiento from "../../shared/components/shared-view-caja-movimiento";

export interface ViewCajaActualAperturaMovimientosProps extends StackProps {
    cajaApertura: CajaApertura
}

export default function ViewCajaActualAperturaMovimientos({
    cajaApertura,
    ...props
}: ViewCajaActualAperturaMovimientosProps) {
    const openModal = useOpenModal();

    const filterData = useFilters({
        filters: [
            { type: "dateRange", label: "Fecha", fromName: "desde", toName: "hasta" },
            { type: "pagination" }
        ],
        useURL: false,
    })

    const fetchData = useGetAllCajaActualAperturaMovimientosQuery(cajaApertura.id, filterData.filterData);

    return <Stack gap={3} {...props}>
        <SharedViewCajaAperturaMovimientos
            fetchData={fetchData}
            filterData={filterData}
            onViewCajaMovimientoClick={(_, movimiento) => openModal("viewMovimiento", movimiento.id)}
        />
        <Dialog code="viewMovimiento" size="md">
            <ModalValueExtractor>
                {movimientoId => <GetCajaActualAperturaMovimientoQuery aperturaId={cajaApertura.id} movimientoId={movimientoId}>
                    {query => <DataFetcher query={query} flex={1}>
                        {movimiento => <>
                            <ModalHeader>Movimiento de Caja - {formatDate(movimiento.fecha, true)}</ModalHeader>
                            <SharedViewCajaMovimiento
                                cajaMovimiento={movimiento}
                                padding={3}
                                flex={1}
                            />
                        </>}
                    </DataFetcher>}
                </GetCajaActualAperturaMovimientoQuery>}
            </ModalValueExtractor>
        </Dialog>
    </Stack>
}